// extracted by mini-css-extract-plugin
export default {"formInput":"FormInput_formInput__zxnvE"};